<template>
  <div id="knowledge-base-article">
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4">
        <vx-card :title="$t('RelatedQuestions')">
          <vs-collapse style="padding: 0px; font-size: 1rem; font-weight: 500" id="que1">
            <vs-collapse-item v-for="que in usageStepsesForWizard" :key="que.id">
              <div slot="header">
                {{ $t(que.question) }}
              </div>
              <ul class="bordered-items">
                <li
                  v-for="que2 in que.answerUrl"
                  :key="que2.id"
                  class="pl-2"
                  @click="setDataForUsage(que2)"
                >
                  {{ $t(que2.title) }}
                </li>
              </ul>
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <vx-card>
          <div class="article-title mb-6">
            <h1>{{ $t(usageSteps.title) }}</h1>
          </div>
          <UsageWizard
            :isSidebarActiveUsage="isSidebarActiveUsage"
            @closeUsageWizard="closeUsageWizard"
            :steps="usageSteps.steps"
            :title="'MatchStockWithExcelUsage'"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mounted } from "vue-barcode";
import UsageWizard from "../components/global-components/UsageWizard.vue";
import UsageSteps from "./UsageSteps";
export default {
  components: {
    UsageWizard,
  },
  data() {
    return {
      usageSteps: [],
      isSidebarActiveUsage: false,
      steps: [],
      usageStepsesForWizard: [],
    };
  },
  methods: {
    setDataForUsage(que2) {
      console.log(que2);
      this.usageSteps = que2;
    },
    closeUsageWizard(val = false) {
      this.isSidebarActiveUsage = val;
    },
  },
  mounted() {
    let usageStepTitle = this.$route.params.title;
    this.usageStepsesForWizard = UsageSteps[usageStepTitle];
    console.log(this.usageStepsesForWizard);
  },
};
</script>
<style lang="scss">
.vs-collapse-item--header {
  font-size: 1rem;
}
</style>
